<template>
    <div v-if="cart.id" class="container px-2 px-lg-4">
        <BaseHeader :title="title" removeSearchBar :redirectBack="previousPage" >
            <div class="row">
                <div class="col-lg-6 col-12 btn-group">
                    <BaseButton class="btn-success " @click="accessCart(cart.url)">Acessar</BaseButton>
                </div>
                <div class="col-lg-6 col-12 mt-lg-0 mt-3 btn-group">
                    <BaseButton class="btn-success" @click="cartSubmit">Salvar</BaseButton>
                </div>
            </div>
        </BaseHeader>
        <div class="row">
            <div class="col-xl-8 col-12">
                <div class="box_content p-4">
                    <div class="row">
                        <div class="col-md-6 col-12">
                            <p class="mb-3">
                                <strong class="d-block">Nome</strong>
                                 {{ cart.client.name}}
                            </p>
                        </div>
                        <div class="col-md-6 col-12">
                            <p class="mb-3">
                                <strong class="d-block">Telefone</strong>
                                {{ cart.client.phone }}
                            </p>
                        </div>
                        <div class="col-md-6 col-12">
                            <p class="mb-3">
                                <strong class="d-block">E-mail</strong>
                                {{ cart.client.email }}
                            </p>
                        </div>
                        <div class="col-md-6 col-12">
                            <p class="mb-3">
                                <strong class="d-block">Data</strong>
                                {{ globalStore.formatDate(cart.created_at) }}
                            </p>
                        </div>
                    </div>
                </div>
                <div class="box_content">
                    <div class="table-responsive">
                        <table class="table">
                            <thead>
                                <tr>
                                    <th>ID</th>
                                    <th>Produto</th>
                                    <th>Quantidade</th>
                                    <th>Total</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(product, key) in cart.products" :key="key">
                                    <td>
                                        {{ product.id }}
                                    </td>
                                    <td>{{ product.title }}</td>
                                    <td>{{ product.qty }}</td>
                                    <td>{{ globalStore.formatMoney(product.total) }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            <div class="col-xl-4 col-12">
                <div class="box_content p-4">
                    <h6 class="mb-3">Alterar status</h6>
                    <BaseSelect
                        id="status"
                        :items="cartStatusList"
                        v-model="cartStore.cart.status.id"
                        :page="route.name"
                    />
                    <h6 class="mt-5 mb-2">Anotações</h6>
                    <div class="mt-3">
                        <ul v-if="cart.notes" id="order_notes">
                            <li v-for="(note, key) in cart.notes" :key="key">
                                <p class="m-0" v-html="note.text"></p>
                                <span>{{ globalStore.formatDateLong(note.date) }}</span>
                            </li>
                        </ul>
                        <ul v-else id="order_notes">
                            <li><div class="loading_component"></div></li>
                            <li><div class="loading_component"></div></li>
                        </ul>
                    </div>
                    <BaseInput
                        id="note"
                        class="mb-3"
                        textarea
                        v-model="cartStore.cart.note"
                        :page="route.name"
                    />
                    <p>Lembrete</p>
                    <BaseDatePicker placeholder="" id="reminder" class="mb-2" v-model="cartStore.cart.reminder" :page="route.name"/>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { useRoute, useRouter } from 'vue-router';
import { computed, ref, onBeforeMount } from 'vue';
import { storeToRefs } from 'pinia'
const route = useRoute();
const router = useRouter();

const cart_id = computed(function () {
    return route.params.id;
});

const title = {title: 'Checkout abandonado #' + cart_id.value + '', icon: 'fa-clock-rotate-left'};

import { useGlobalStore } from '@/stores/global';
const globalStore = useGlobalStore();

import { useCartStore } from '@/stores/cart';
const cartStore = useCartStore();
const { cart } = storeToRefs(cartStore);

const isLoading = ref(true);

const cartStatusList = ref({
    0: 'Abandonado',
    1: 'Pedido realizado',
    2: 'Convertido',
    3: 'Pendente',
    4: 'Não convertido',
})

const previousPage = ref(null)

onBeforeMount(async () => {
    if(!globalStore.hasPermissionTo('abandoned_carts')) {
        return router.push('/403');
    }
    previousPage.value = router.options.history.state.back;

    if(cart.value.id == undefined) {
        await cartStore.tryCart(cart_id.value).then(() => {
            isLoading.value = false
        })
    }
})

function accessCart(url){
    window.open(url, '_blank');
}

const formLoading = ref(false);

async function cartSubmit() {

    if(formLoading.value === true) {
        return;
    }

    let params = ['status', 'note', 'reminder']

    cartStore.cart.status = cartStore.cart.status.id

    formLoading.value = true;
    globalStore.loader('show');
    cartStore.tryUpdateCart(route.name, cartStore.cart.id, params).then(() =>{
        formLoading.value = false;
        cartStore.tryCart(cartStore.cart.id)
        router.push('/recovery/abandoned-carts/' + cart_id.value);
        globalStore.loader('hide');
    });
}

</script>

<style scoped>

strong{
    font-weight: 600;
}

#order_notes {
  padding: 5px;
  margin-bottom: 0;
}

#order_notes li {
  list-style: none;
  padding-bottom: 15px;
  padding-left: 30px;
  position: relative;
}

#order_notes li:last-child {
  margin-bottom: 0;
  padding-bottom: 0;
  border-bottom: 0;
}

#order_notes li span {
  display: block;
  font-size: 12px;
  color: #a0a0a0;
}

#order_notes li:before {
  content: '';
  width: 14px;
  height: 14px;
  background-color: #ffffff;
  border-radius: 25px;
  position: absolute;
  margin-top: 4px;
  left: -2px;
  border: 3px #205ed9 solid;
  z-index: 1;
}

#order_notes li:after {
  content: '';
  width: 4px;
  height: 100%;
  background-color: #205ed9;
  position: absolute;
  margin-top: 0px;
  top: -16px;
  left: 3px;
}

#order_notes li:first-child:after {
  margin-top: 22px;
}

#order_notes li:last-child:after {
  margin-top: -6px;
}

</style>